<template>
  <transition name='fade'>
    <div
      class="modal headimg_box move_box"
      v-if='visible'
    >
      <div class="headimg">
        <div class="title msp_icon_close">
          <span
            class="title_name"
            v-if='moveArticleType === "matterPosition" || moveArticleType === "picToMatter"'
          >选择保存位置</span>
          <span
            class="iconfont el-icon-close"
            @click.stop='closeBox()'
          ></span>
        </div>
        <el-scrollbar class="move_content masp_repo_tree">
          <matterrepotree
            :hightLight='hightLight'
            :showCheckbox='showCheckbox'
            ref='matterTreeRef'
            :checkStrictly='checkStrictly'
            @checkChangeFolder='checkChangeFolder'
            @checkChangeFolderList='checkChangeFolderList'
            @getmattersavepath='getmattersavepath'
          ></matterrepotree>
        </el-scrollbar>

        <div class="headimg_buttom">
          <el-button @click.native='closeBox()'>取消</el-button>
          <el-button
            type="primary"
            style="margin-left:20px;"
            @click.native='sureMoveArticle()'
            v-if='!isLoading'
          >确定</el-button>
          <el-button
            type="primary"
            style="background:#ccc;color:#fff;"
            v-if='isLoading'
          >加载中</el-button>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>

import * as api from '../../../api'
import axios from 'axios'
import matterrepotree from '../repotree/matterrepotree'

export default {
  name: 'savematterposition',
  data () {
    return {
      visible: false,
      currentChoiceFolder: '',
      moveArticleInfo: '',
      moveArticleType: "",
      currentChoiceFolderList: [],
      isLoading: false,
      showCheckbox: true,
      hightLight: true,
      currentFolderLocation: ''
    }
  },

  mounted () {
    this.$root.eventHub.$on('setMatterPositionModel', (data, type) => {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.matterTreeRef.getMansuriptData(data)
      })

      this.moveArticleInfo = data
      this.moveArticleType = type

    })

  },
  destroyed () {
    this.$root.eventHub.$off('setMatterPositionModel')
  },
  components: {
    matterrepotree
  },
  computed: {
    checkStrictly () {
      if (this.moveArticleType === 'matterPosition' || this.moveArticleType === 'picToMatter') {
        return true
      } else {
        return true
      }
    }
  },
  methods: {
    closeBox () {
      this.visible = false
    },
    checkChangeFolder (data) {
      this.currentChoiceFolder = data
    },
    checkChangeFolderList (data) {
      this.currentChoiceFolderList = data
    },
    getOperateType () {
      return this.moveArticleType
    },
    getmattersavepath (arr) {
      var path = ''
      for (var i = 0; i < arr.length; i++) {
        path = path + '>' + arr[i]
      }
      this.currentFolderLocation = path.substring(1)
    },
    sureMoveArticle () {
      if (this.currentChoiceFolder || this.currentChoiceFolderList.length > 0) {
        if (this.moveArticleType === 'matterPosition') {
          this.moveArticleInfo = this.currentChoiceFolder[0]
          this.$set(this.moveArticleInfo, 'currentFolderLocation', this.currentFolderLocation)
          this.$root.eventHub.$emit('getCurrentFolderModel', this.moveArticleInfo)
          this.$root.eventHub.$emit('getCurrentMatterFolder', this.moveArticleInfo)
          this.visible = false
        } else if (this.moveArticleType === 'picToMatter') {
          this.moveArticleInfo = this.currentChoiceFolder[0]
          this.$set(this.moveArticleInfo, 'currentFolderLocation', this.currentFolderLocation)
          this.$root.eventHub.$emit('getCurrentMatterFolder', this.moveArticleInfo)
          this.visible = false
        }
      } else {
        this.$notify.warning({
          title: '警告',
          message: '请选择文件夹'
        });
      }

    }

  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='stylus' scoped>
.headimg_box
  .headimg
    position relative
    width 586px
    height 640px
    border-radius 6px
    background #fff

    .title
      clear both
      box-sizing border-box
      padding 0 14px 0 14px
      height 48px
      border-bottom 1px solid #E4E7ED

      .title_name
        span-medium-title()
        float left
        line-height 48px

      .iconfont
        float right
        font-size 22px
        line-height 48px
        cursor pointer

    .move_content
      box-sizing border-box
      margin-top 10px
      padding-left 14px
      height 510px

    .headimg_buttom
      position absolute
      bottom 20px
      left 0
      display flex
      justify-content center
      box-sizing border-box
      width 100%
      border-radius 0 0 6px 6px

      button
        width 74px
        height 28px
        center()
        line-height 0
</style>
